<template>
    <div class="relative inline-block my-0 mx-2">
        <div
            :title="file.status==='failed'?('Upload failed - '+file.errorMessage):''"
            class="border border-2 border-gray-300 shadow-sm rounded-md overflow-hidden relative hover:border-blue-500"
            :ref="'filePreview'+file.id"
            :class="highlighted?'border-blue-500':'border-gray-300'"
            @click="$emit('click')"
            @mouseover="$emit('mouseover')"
            @mouseleave="$emit('mouseleave')"
        >
            <img loading="eager" alt="…" :src="fileUrl(file)" class="w-24 h-24 object-cover transition-opacity"
                 :class="file.status!=='uploaded'?'opacity-40':'opacity-100'">
            <div
                class="transition-opacity rounded-md border-2 border-gray-400 w-8 h-8 bg-gray-50 absolute top-2 left-2 text-blue-500 flex items-center justify-center"
                :class="file.status==='uploading'?'opacity-80':'opacity-0'">
                <span class="flex-shrink fas fa-upload"></span>
            </div>
            <div
                class="transition-opacity rounded-md border-2 border-gray-400 w-8 h-8 bg-gray-50 absolute top-2 left-2 text-gray-500 flex items-center justify-center"
                :class="file.status==='queued'?'opacity-80':'opacity-0'">
                <span class="flex-shrink fas fa-hourglass-half"></span>
            </div>
            <div v-if="file.status==='failed'"
                 class="transition-opacity rounded-md border-2 border-gray-400 w-8 h-8 bg-gray-50 absolute top-2 left-2 text-gray-500 flex items-center justify-center"
                 :class="file.status==='failed'?'opacity-80':'opacity-0'">
                <span class="flex-shrink text-red-600 fas fa-exclamation-triangle"></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        file: {},
        highlighted: {
            type: Boolean, default: false
        }
    },
    data() {
        return {
            renderCount: 0,
        }
    },
    computed: {},
    methods: {
        fileUrl(file) {
            if (file.thumbnail) {
                return file.thumbnail + '&ur=' + this.renderCount
            }
            if (file.file) {
                return URL.createObjectURL(file.file)
            }
        },
    },
    watch: {},
}
</script>
